import { useEffect, useRef } from 'react'

import type { QueueItem } from '~/components/player/types'
import { coverArtUrlFor } from '~/lib/cover-art'

interface UseDesktopNotificationsOptions {
  enabled: boolean
  queue: QueueItem[]
  currentIndex: number
}

export function useDesktopNotifications({
  enabled,
  queue,
  currentIndex,
}: UseDesktopNotificationsOptions) {
  const lastNotifiedIdRef = useRef<number | null>(null)

  useEffect(() => {
    if (!enabled) return
    if (Notification.permission !== 'granted') return
    if (currentIndex < 0 || currentIndex >= queue.length) return

    const track = queue[currentIndex]!
    if (track.id === lastNotifiedIdRef.current) return
    lastNotifiedIdRef.current = track.id

    const artPath = coverArtUrlFor({
      type: 'tracks',
      id: track.id,
      coverArt: track.coverArt,
      size: 120,
    })
    const n = new Notification(track.title, {
      body: `${track.artist} — ${track.album}`,
      icon: artPath ? `${window.location.origin}${artPath}` : undefined,
      silent: true,
    })

    // Auto-close after 4s so it doesn't linger
    const timer = setTimeout(() => n.close(), 4000)
    return () => {
      clearTimeout(timer)
      n.close()
    }
  }, [enabled, queue, currentIndex])
}
